"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIClientSettingsEntity = void 0;
const iclient_settings_entity_mail_settings_1 = require("./iclient-settings-entity-mail-settings");
const iclient_settings_entity_maintenance_settings_1 = require("./iclient-settings-entity-maintenance-settings");
function parseIClientSettingsEntity(data) {
    if (data.mailSettings !== null && typeof data.mailSettings === 'object')
        data.mailSettings = (0, iclient_settings_entity_mail_settings_1.parseIClientSettingsEntityMailSettings)(data.mailSettings);
    if (data.maintenanceSettings !== null && typeof data.maintenanceSettings === 'object')
        data.maintenanceSettings = (0, iclient_settings_entity_maintenance_settings_1.parseIClientSettingsEntityMaintenanceSettings)(data.maintenanceSettings);
    return data;
}
exports.parseIClientSettingsEntity = parseIClientSettingsEntity;
